export default class MyCosmoChildDelete {
    constructor($dialog) {
        this.$dialog = $dialog;
        this.id = $dialog.getAttribute('id');
        this.$openButtons = Array.from(document.querySelectorAll('[data-my-cosmo-child-delete-open]'))
            .filter($button => $button.getAttribute('aria-controls') === this.id);

        this.$openButtons.forEach($button => {
            $button.addEventListener('click', () => this.open());
        });

        this.$dialog.querySelectorAll('[data-my-cosmo-child-delete-close]').forEach($button => {
            $button.addEventListener('click', () => this.close());
        });

        this.$dialog.addEventListener('click', event => {
            if (event.target === this.$dialog) {
                this.close();
            }
        });
    }

    open() {
        if (typeof this.$dialog.showModal === 'function') {
            this.$dialog.showModal();
            return;
        }

        this.$dialog.setAttribute('open', 'open');
    }

    close() {
        if (typeof this.$dialog.close === 'function') {
            this.$dialog.close();
            return;
        }

        this.$dialog.removeAttribute('open');
    }
}
